import ColisScanner from "@/components/colis/ColisScanner";
import ConfirmationDialog from "@/components/dialogs/ConfirmationDialog";
import ActionButton from "@/components/loader-button/ActionButton";
import { NavigationRoutes } from "@/components/navigation/constants";
import ReturnHeader from "@/components/return/ReturnHeader";
import { Toaster } from "@/components/ui/toaster";
import { toast } from "@/hooks/use-toast";
import { Colis, ReturnToCreate } from "@/interfaces/Return";
import { confirmExpedition } from "@/services/expedition-validation.service";
import { RootState } from "@/store/store";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const ReturnExpeditionValidationPage: React.FC = () => {
  const navigate = useNavigate();
  const [scannedColis, setScannedColis] = React.useState<Colis[]>([]);
  const [isLoading, setIsloading] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);
  const return_ = useSelector((state: RootState) => state.return.return);

  const validationButtonDisabled = () => {
    return scannedColis.length !== return_.colis?.length;
  };

  const handleValidation = async () => {
    if (isOpen === false) {
      setIsOpen(true);
      return;
    }
    const request = {
      numTournee: return_.numTournee.toString() || "",
      isSellerVIP: return_.isSellerVIP,
      sellerId: return_.sellerId,
      entityId: return_.entityId,
    } as ReturnToCreate;
    try {
      setIsOpen(false);
      setIsloading(true);
      const response = await confirmExpedition(request);
      if (response.status === 200 && response.data.success === true) {
        toast({
          title: "Réception validée",
          variant: "success",
        });
        navigate(NavigationRoutes.DASHBOARD, { replace: true });
      } else {
        toast({
          title: "Erreur lors de la validation",
          variant: "destructive",
        });
      }
    } catch (error) {
      toast({
        title: "Erreur lors de la validation",
        variant: "destructive",
      });
    } finally {
      setIsloading(false);
    }
  };

  return (
    <div className="flex flex-col h-full gap-4">
      <ReturnHeader return_={return_} />
      <ColisScanner
        scannedColis={scannedColis}
        setScannedColis={setScannedColis}
        colis={return_.colis}
      />
      <div className="px-4 flex space-x-4 flex-row">
        <ActionButton
          loading={isLoading}
          disabled={validationButtonDisabled() || isLoading}
          handleClick={handleValidation}
          label="Valider"
        />
      </div>
      <Toaster />
      <ConfirmationDialog
        handleValidate={handleValidation}
        actionButtonText="Valider"
        confirmationMessage="Confirmer la validation de l'expédition"
        open={isOpen}
        setOpen={setIsOpen}
      />
    </div>
  );
};

export default ReturnExpeditionValidationPage;
